var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.isinput ? 'selected_status' : 'unselected_status', 'button'],on:{"click":_vm.onSubmit}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }